import { ISettings } from 'src/interfaces';
import http from './http';

class SettingsService {
  static getSettings(params: { companyId: string }): Promise<ISettings> {
    return http.get('/general-config', { headers: { companyId: params.companyId } }).then(response => response.data);
  }

  static patchSettings(data: { id: string }) {
    return http.patch(`/general-config/${data.id}`);
  }

  static getPayrollSettings() {
    return http.get('/general-config/payroll').then(response => response.data);
  }

  static getPayrollSettingsEmails(companyId: string) {
    return http.get(`/general-config/payroll/emails/${companyId}`).then(response => response.data);
  }

  static deletePayrollSettingsEmails(emailId: string) {
    return http.delete(`/general-config/payroll/emails/${emailId}`);
  }

  static createPayrollSettingsEmails(body: { email: string; companyId: string }) {
    return http.post('/general-config/payroll/emails', body);
  }
}
export default SettingsService;
